import React, { useContext } from "react";
import Section from "../../Section/Section";
import Overview from "./Overview";
import FormStepSizes from "./FormStepSizes";
import FormStepHeaters from "./FormStepHeaters";
import FormStepAccessories from "./FormStepAccessories";
import FormStepInteriorExterior from "./FormStepInteriorExterior";
import SidebarContainer from "../../SidebarContainer/SidebarContainer";
import { ConfigurationContext } from "./ConfigurationContext";
import { isSubmitDisabled } from "./utils";
import {useSubmitQuote} from "../../../hooks/useSubmitQuote";

const Sidebar = ({ sections }) => {
  const { size, heaters, interiorexterior, accessories, totalPrice } =
    useContext(ConfigurationContext);
  const { submitFormQuote, mapArrayToString, mapItemToString, mapItemsForZapier } = useSubmitQuote();

  const handleAddToCart = async ({name, phone, email, postCode, sendLink, reference, screenShot}) => {
    const getLiner = (size, forZapier) => {
      if (size?.id === 3) {
        return forZapier ? "Fibreglass Liner" : "Fibreglass Liner (£0)"
      }
      return forZapier ? mapItemsForZapier(interiorexterior.liner) : mapArrayToString(interiorexterior.liner)
    }

    const coCartData = {
      id: "149",
      quantity: "1",
      item_data: {
        nyp: totalPrice,
        custom_data: {
          Size: mapItemToString(size),
          Heater: mapItemToString(heaters.heater),
          Upgrades: mapArrayToString(heaters.upgrades),
          Wood: mapItemToString(interiorexterior.wood),
          "Wood Treatment": mapArrayToString(interiorexterior.woodTreatment),
          Liner: getLiner(size),
          "Liner Colour": mapItemToString(interiorexterior.linerColor),
          Lid: mapItemToString(interiorexterior.lidCover),
          "Flue / Drain Add-ons": mapArrayToString(accessories.flueDrain),
          "Electrical Add-ons": mapArrayToString(accessories.electrical),
          "Wooden Add-ons": mapArrayToString(accessories.wooden),
          "Water Care Add-ons": mapArrayToString(accessories.waterCare),
        },
      },
    };

    const zapierData = {
      name,
      phone,
      email,
      "Image hash": screenShot,
      "Total price": `${totalPrice}`,
      "Post code": postCode,
      "Send emails": sendLink,
      "Reference": reference,
      Size: mapItemsForZapier(size),
      Heater: mapItemsForZapier(heaters.heater),
      Upgrades: mapItemsForZapier(heaters.upgrades),
      Wood: mapItemsForZapier(interiorexterior.wood),
      "Wood Treatment": mapItemsForZapier(interiorexterior.woodTreatment),
      "Liner Type": getLiner(size, true),
      "Liner Colour": mapItemsForZapier(interiorexterior.linerColor),
      Lid: mapItemsForZapier(interiorexterior.lidCover),
      "Flue / Drain Add-ons": mapItemsForZapier(accessories.flueDrain),
      "Electrical Add-ons": mapItemsForZapier(accessories.electrical),
      "Wooden Add-ons": mapItemsForZapier(accessories.wooden),
      "Water Care Add-ons": mapItemsForZapier(accessories.waterCare),
    }

    return await submitFormQuote({coCartData, size, totalPrice, zapierData}, 'ofuro')
  };

  return (
    <SidebarContainer
      sections={sections}
      title={`${size?.label} Ofuro Hot Tub`}
      totalPrice={totalPrice}
      isSubmitDisabled={isSubmitDisabled(size, heaters, interiorexterior)}
      onAddToCart={handleAddToCart}
      name='ofuroFormStep'
    >
      {(activeSection, setActiveSection) => [
        <Section
          key={0}
          index={0}
          open={activeSection === 0}
          filled={activeSection > 0}
          setActiveSection={setActiveSection}
          title={sections[0].title}
          description={sections[0].description}
          changedField={size}
        >
          <FormStepSizes sizeField={sections[0].fields.size} />
        </Section>,
        <Section
          key={1}
          index={1}
          open={activeSection === 1}
          filled={activeSection > 1}
          setActiveSection={setActiveSection}
          title={sections[1].title}
          description={sections[1].description}
          changedField={heaters}
        >
          <FormStepHeaters
            heaterField={sections[1].fields.heater}
            upgradesField={sections[1].fields.upgrades}
          />
        </Section>,
        <Section
          key={2}
          index={2}
          open={activeSection === 2}
          filled={activeSection > 2}
          setActiveSection={setActiveSection}
          title={sections[2].title}
          description={sections[2].description}
          changedField={interiorexterior}
        >
          <FormStepInteriorExterior
            woodField={sections[2].fields.wood}
            woodTreatmentField={sections[2].fields.woodTreatment}
            seatingField={sections[2].fields.seating}
            electricalField={sections[3].fields.electrical}
            linerField={sections[2].fields.liner}
            linerColorField={sections[2].fields.linerColor}
            lidCoverField={sections[2].fields.lidCover}
          />
        </Section>,
        <Section
          key={3}
          index={3}
          open={activeSection === 3}
          filled={activeSection > 3}
          setActiveSection={setActiveSection}
          title={sections[3].title}
          description={sections[3].description}
          changedField={accessories}
        >
          <FormStepAccessories
            flueDrainField={sections[3].fields.flueDrain}
            electricalField={sections[3].fields.electrical}
            woodenField={sections[3].fields.wooden}
            waterCareField={sections[3].fields.waterCare}
          />
        </Section>,
        <Section
          key={sections.length}
          index={sections.length}
          open={activeSection === sections.length}
          title="Overview"
        >
          <Overview
            size={size}
            heaters={heaters}
            interiorexterior={interiorexterior}
            accessories={accessories}
            totalPrice={totalPrice}
          />
        </Section>,
      ]}
    </SidebarContainer>
  );
};

export default Sidebar;
